import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

const mutation = gql`
  mutation ticketBulkCreate($attributes: BulkCreateTicketAttributesInput!) {
    ticketBulkCreate(attributes: $attributes)
  }
`

export default function useTicketBulkCreate() {
  const { onMutate: onTicketBulkCreate, loading } = useSafeRunMutation({
    mutation,
    responsePath: 'ticketBulkCreate',
    successMessage: 'Creating tickets has started'
  })

  return { onTicketBulkCreate, loading }
}
